import { Box, Grid, Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { localize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { ReferralCard } from "./components/ReferralCard";
import { RewardsList } from "./components/RewardsList";
import { LoyaltyStoreAccess } from "./store";
import { useSmartrrTheme } from "../../../hooks/useSmartrrTheme";
import { TiersProgressBar } from "./components/TiersProgressBar";

export const Loyalty = () => {
  const referral = LoyaltyStoreAccess.useReferralProgram();
  const isSpecialReferralsEnabled = !!LoyaltyStoreAccess.useSpecialReferralsVariantId();
  const theme = useSmartrrTheme();
  const showTierProgressBar = LoyaltyStoreAccess.useIsTiersEnabled();
  const showSectionTitles = theme.modernThemeSettings?.showHide.showSectionTitles;

  return (
    <Box sx={{ marginTop: "40px" }} className={prefixClassName("loyalty-content-container")}>
      <span className="anchor" id="loyalty" />
      {showSectionTitles ? (
        <Typography className={"loyalty-title"} variant="h2">
          {localize("loyalty.title")}
        </Typography>
      ) : null}
      <Stack direction="column" gap="20px">
        {showTierProgressBar ? <TiersProgressBar /> : <React.Fragment />}
        <Grid
          container
          spacing={"20px"}
          className={prefixClassName("loyalty-grid")}
          sx={{ position: "relative" }}
        >
          {isSpecialReferralsEnabled ? <React.Fragment /> : <RewardsList />}
          {referral ?? isSpecialReferralsEnabled ? <ReferralCard /> : <React.Fragment />}
        </Grid>
      </Stack>
    </Box>
  );
};
